import script from "./VLotPositionCreateFormMain.vue?vue&type=script&setup=true&lang=js"
export * from "./VLotPositionCreateFormMain.vue?vue&type=script&setup=true&lang=js"

import "./VLotPositionCreateFormMain.vue?vue&type=style&index=0&id=55037ac5&scoped=true&lang=css"

import exportComponent from "/var/www/tender_demo/www/spa/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55037ac5"]])

export default __exports__